import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: () => import("./views/Index.vue"),    
        children: [
            {
                path: "/home",
                redirect: '/'
            },
            {
                path: "/",
                meta: {
                    pageType: 'landing'
                },
                component: () => import("./views/Home.vue")
            }            
        ]
    },    
    {
        path: "/about-us",        
        name: 'About',
        meta: {
          pageType: 'inside',
          slug: 'about-us'
        },
        component: () => import("./views/About.vue")
    },
    {
        path: "/services",        
        name: 'Services',
        meta: {
          pageType: 'inside',
          slug: 'services'
        },
        component: () => import(/* webpackPrefetch: true */ "./views/Services.vue"),
        children: [
            {
                name: 'SingleService',
                path: "/services/:slug",
                meta: {
                    slug: 'services'
                }
            },
        ]
    },
    {
        path: "/contact-us",        
        name: 'Contact',
        meta: {
          pageType: 'inside',
          slug: 'contact-us'
        },
        component: () => import("./views/Contact.vue")
    },
    {
        path: "/account",        
        name: 'Account',
        meta: {
          pageType: 'inside',
          slug: 'account'
        },
        component: () => import("./views/Account.vue"),
        children: [
            {
                name: 'Login',
                path: "/account/login",
                meta: {
                    slug: 'login'
                }
            },
            {
                name: 'Registration',
                path: "/account/registration",
                meta: {
                    slug: 'registration'
                }
            }
        ]
        
    },
    {
        path: "/dashboard",        
        name: 'Dashboard',
        meta: {
          pageType: 'inside',
          slug: 'dashboard'
        },
        component: () => import("./views/Dasboard.vue"),
        
    },
    {
        path: "/qr-code",        
        name: 'QR Code',
        meta: {
          pageType: 'inside',
          slug: 'qr-code'
        },
        component: () => import(/* webpackPrefetch: true */ "./views/QRCode.vue"),
        
    },
    {
        path: "/faq",        
        name: 'FAQ',
        meta: {
          pageType: 'inside',
          slug: 'faq'
        },
        component: () => import("./views/FAQ.vue"),
        
    },
    {
        path: "/pricing",        
        name: 'Pricing',
        meta: {
          pageType: 'inside',
          slug: 'pricing'
        },
        component: () => import(/* webpackPrefetch: true */ "./views/Pricing.vue"),
        
    },
    {
        path: "/privacy-policy",        
        name: 'Privacy Policy',
        meta: {
          pageType: 'inside',
          slug: 'privacy-policy'
        },
        component: () => import("./views/CMS.vue"),
    },
    {
        path: "/terms-conditions",        
        name: 'Privacy Policy',
        meta: {
          pageType: 'inside',
          slug: 'terms-conditions'
        },
        component: () => import("./views/CMS.vue"),
    }
    /*{
        path: "/404",
        name: '404',
        meta: {
          pageType: 'inside'
        },
        component: () => import("./views/404.vue")
    }*/
]

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);
    
    next();
  });
export default router